import { render, staticRenderFns } from "./invoice-batches.vue?vue&type=template&id=59f6845b&"
import script from "./invoice-batches.vue?vue&type=script&lang=js&"
export * from "./invoice-batches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports